import { useCallback } from 'react';

import { IAccount } from 'modules/common/types';
import { useSelectAccount } from 'modules/account/hooks/useSelectAccount';
import { useUser } from 'modules/user/hooks/useUser';

export interface UseAccountItemProps {
  account: IAccount;
  onSelect: () => void;
}

export const useAccountItem = ({
  account: { address: accountAddress },
  onSelect,
}: UseAccountItemProps) => {
  const { address: userAddress } = useUser();

  const isPersonalAccount = accountAddress === userAddress;

  const { isSelected, selectAccount } = useSelectAccount({
    accountAddress,
    onSelect,
  });

  const onClick = useCallback(async () => {
    if (!isSelected) {
      selectAccount();
    }
  }, [isSelected, selectAccount]);

  return { isSelected, isPersonalAccount, onClick };
};
